module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-content order-content"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    staticClass: "order-number"
  }, [_vm._v("订单编号：" + _vm._s(_vm.orderDetailData.orderSn))]), _vm._v(" "), _c('div', {
    staticClass: "order-status"
  }, [_c('ul', [_c('li', {
    staticClass: "order-detail-one order-status-one order-status-default",
    class: {
      'yiwancheng': _vm.statusActive.one
    }
  }, [_c('div', {
    staticClass: "order-current-status"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-status-text"
  }, [_vm._v("提交订单")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v(_vm._s(_vm.createDate))]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v(_vm._s(_vm.createTime))])]), _vm._v(" "), _c('li', {
    staticClass: "order-detail-two order-status-two order-status-default",
    class: {
      'yiwancheng': _vm.statusActive.two
    }
  }, [_c('div', {
    staticClass: "order-current-status"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-status-text"
  }, [_vm._v("付款成功")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v(_vm._s(_vm.payDate))]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v(_vm._s(_vm.payTime))])]), _vm._v(" "), _c('li', {
    staticClass: "order-detail-three order-status-two order-status-default",
    class: {
      'yiwancheng': _vm.statusActive.three
    }
  }, [_c('div', {
    staticClass: "order-current-status"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-status-text"
  }, [_vm._v("货商发货")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v(_vm._s(_vm.sendGoodsDate))]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v(_vm._s(_vm.sendGoodsTime))])]), _vm._v(" "), _c('li', {
    staticClass: "order-detail-four order-status-two order-status-default",
    class: {
      'yiwancheng': _vm.statusActive.four
    }
  }, [_c('div', {
    staticClass: "order-current-status"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-status-text"
  }, [_vm._v("订单完成")]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v(_vm._s(_vm.completeDate))]), _vm._v(" "), _c('div', {
    staticClass: "order-status-time"
  }, [_vm._v(_vm._s(_vm.completeTime))])])])]), _vm._v(" "), (_vm.logisticsInfo.length > 0) ? _c('div', {
    staticClass: "order-content-wrap"
  }, [_c('table', {
    staticClass: "shelves-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', {
    staticClass: "order-tbody"
  }, _vm._l((_vm.logisticsInfo), function(info, idx) {
    return _c('tr', {
      key: idx,
      staticStyle: {
        "border-bottom": "1px solid #e5e5e5"
      }
    }, [_c('td', _vm._l((info.packetDetails), function(item, index) {
      return _c('div', {
        key: index,
        staticStyle: {
          "display": "flex",
          "-webkit-box-align": "center",
          "-webkit-align-items": "center",
          "align-items": "center",
          "-webkit-box-pack": "start",
          "-webkit-justify-content": "flex-start",
          "justify-content": "flex-start",
          "padding": "20px",
          "box-sizing": "border-box"
        }
      }, [(_vm.orderbox) ? _c('div', {
        staticStyle: {
          "position": "relative"
        }
      }, [_c('img', {
        staticStyle: {
          "width": "80px",
          "height": "80px"
        },
        attrs: {
          "src": _vm.imgAddress + item.picture
        },
        on: {
          "error": function($event) {
            return _vm.error(1)
          }
        }
      }), _vm._v(" "), (item.isOwner > 0) ? _c('img', {
        staticStyle: {
          "width": "22px",
          "height": "22px",
          "position": "absolute",
          "z-index": "100",
          "top": "initial",
          "left": "0"
        },
        attrs: {
          "src": require("../assets/img/is_owns.png"),
          "alt": ""
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "margin-left": "20px"
        }
      }, [_c('div', {
        staticClass: "line-clamp-1-s",
        staticStyle: {
          "color": "#494949"
        }
      }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('div', {
        staticStyle: {
          "color": "#999",
          "font-size": "12px"
        }
      }, [_vm._v("规格：" + _vm._s(item.specName))]), _vm._v(" "), _c('div', {
        staticStyle: {
          "color": "#999",
          "font-size": "12px"
        }
      }, [_vm._v("件数：" + _vm._s(item.num))])])])
    }), 0), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-left": "1px solid #e5e5e5"
      }
    }, [_c('div', {
      staticStyle: {
        "padding": "20px",
        "box-sizing": "border-box"
      }
    }, [_c('div', [_vm._v("\n                物流公司：\n                "), _c('span', [_vm._v(_vm._s(info.expressName))])]), _vm._v(" "), (info.driverName == '') ? _c('div', [_vm._v("\n                收货方式：\n                "), _c('span', [_vm._v("普通快递")])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                物流单号：\n                "), _c('span', [_vm._v(_vm._s(info.expressNo))])]), _vm._v(" "), (info.driverName != '') ? _c('div', [_vm._v("\n                司机姓名：\n                "), _c('span', [_vm._v(_vm._s(info.driverName))])]) : _vm._e(), _vm._v(" "), (info.driverName != '') ? _c('div', [_vm._v("\n                手机号：\n                "), _c('span', [_vm._v(_vm._s(info.driverMobile))])]) : _vm._e(), _vm._v(" "), (info.driverName != '') ? _c('div', [_vm._v("\n                车牌号：\n                "), _c('span', [_vm._v(_vm._s(info.plateNumber))])]) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-left": "1px solid #e5e5e5"
      }
    }, [_c('div', {
      staticClass: "order-logistics-content",
      staticStyle: {
        "border": "none"
      }
    }, _vm._l((info.logisticslList), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "order-logistics-item-wrap"
      }, [_c('div', {
        staticClass: "order-logistics-item",
        class: {
          'current': index === info.logisticslList.length - 1
        }
      }, [_c('span', [_vm._v(_vm._s(item.datetime))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.remark))])])])
    }), 0)])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.isSendGoods && false) ? _c('div', {
    staticClass: "order-content-wrap"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.logisticsInfo), function(info, idx) {
    return _c('div', {
      class: _vm.orderbox ? 'order-info-contentt' : 'order-info-content',
      staticStyle: {
        "padding-left": "560px"
      }
    }, [(_vm.orderbox) ? _c('div', {
      staticClass: "order-info-baoguo",
      staticStyle: {
        "width": "300px"
      }
    }, _vm._l((info.packetDetails), function(item, index) {
      return _c('td', {
        key: index,
        staticClass: "order-table-image",
        staticStyle: {
          "padding-top": "25px",
          "width": "300px"
        }
      }, [_c('div', {
        staticClass: "order-table-image-wrap"
      }, [_c('img', {
        attrs: {
          "src": _vm.imgAddress + item.picture
        },
        on: {
          "error": function($event) {
            return _vm.error(1)
          }
        }
      }), _vm._v(" "), (item.isOwner > 0) ? _c('img', {
        staticStyle: {
          "width": "22px",
          "height": "22px",
          "position": "absolute",
          "z-index": "100",
          "top": "initial",
          "left": "0"
        },
        attrs: {
          "src": require("../assets/img/is_owns.png"),
          "alt": ""
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
        staticClass: "order-goods-name line-clamp-1-s"
      }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('div', {
        staticStyle: {
          "color": "#999",
          "font-size": "12px"
        }
      }, [_vm._v("规格：" + _vm._s(item.specName))]), _vm._v(" "), _c('div', {
        staticStyle: {
          "color": "#999",
          "font-size": "12px"
        }
      }, [_vm._v("件数：" + _vm._s(item.num))])])])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      class: _vm.orderbox ? 'order-logistics-infoo' : 'order-logistics-info',
      staticStyle: {
        "left": "320px"
      }
    }, [_c('div', [_vm._v("\n            物流公司：\n            "), _c('span', [_vm._v(_vm._s(info.expressName))])]), _vm._v(" "), (info.driverName == '') ? _c('div', [_vm._v("\n            收货方式：\n            "), _c('span', [_vm._v("普通快递")])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n            物流单号：\n            "), _c('span', [_vm._v(_vm._s(info.expressNo))])]), _vm._v(" "), (info.driverName != '') ? _c('div', [_vm._v("\n            司机姓名：\n            "), _c('span', [_vm._v(_vm._s(info.driverName))])]) : _vm._e(), _vm._v(" "), (info.driverName != '') ? _c('div', [_vm._v("\n            手机号：\n            "), _c('span', [_vm._v(_vm._s(info.driverMobile))])]) : _vm._e(), _vm._v(" "), (info.driverName != '') ? _c('div', [_vm._v("\n            车牌号：\n            "), _c('span', [_vm._v(_vm._s(info.plateNumber))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "order-logistics-content"
    }, _vm._l((info.logisticslList), function(item, index) {
      return _c('div', {
        staticClass: "order-logistics-item-wrap"
      }, [_c('div', {
        staticClass: "order-logistics-item",
        class: {
          'current': index === info.logisticslList.length - 1
        }
      }, [_c('span', [_vm._v(_vm._s(item.datetime))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.remark))])])])
    }), 0)])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-content-wrap"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "order-info-content order-all-info"
  }, [_c('div', {
    staticClass: "order-linkman-info"
  }, [_c('div', [_vm._v("\n            姓名：\n            "), _c('span', [_vm._v(_vm._s(_vm.orderDetailData.linkMan))])]), _vm._v(" "), _c('div', [_vm._v("\n            电话：\n            "), _c('span', [_vm._v(_vm._s(_vm.orderDetailData.mobile))])]), _vm._v(" "), _c('div', [_vm._v("\n            身份证号：\n            "), _c('span', [_vm._v(_vm._s(_vm.orderDetailData.idNumber))])]), _vm._v(" "), _c('div', [_vm._v("\n            收货地址：\n            "), _c('span', [_vm._v(_vm._s(_vm.address))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('div', [_vm._v("\n            父订单编号：\n            "), _c('span', [_vm._v(_vm._s(_vm.orderDetailData.orderObjectSn))])]), _vm._v(" "), _c('div', [_vm._v("\n            订单编号：\n            "), _c('span', [_vm._v(_vm._s(_vm.orderDetailData.orderSn))])]), _vm._v(" "), _c('div', [_vm._v("\n            交易个数：\n            "), _c('span', [_vm._v(_vm._s(_vm.orderDetailData.goodsCount))])]), _vm._v(" "), _c('div', [_vm._v("\n            最终结算金额：\n            "), _c('span', [_vm._v("¥" + _vm._s(_vm.orderDetailData.totalCooperatePrice / 100))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "order-content-wrap"
  }, [_c('table', {
    staticClass: "shelves-table"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', {
    staticClass: "order-tbody"
  }, _vm._l((_vm.goodsList), function(item, index) {
    return _c('tr', {
      staticClass: "order-table-item"
    }, [_c('td', {
      staticClass: "order-table-image"
    }, [_c('div', {
      staticClass: "order-table-image-wrap"
    }, [_c('img', {
      attrs: {
        "src": _vm.imgAddress + item.navigateImg1
      },
      on: {
        "error": function($event) {
          return _vm.error(1)
        }
      }
    }), _vm._v(" "), (item.selfStoreId > 0) ? _c('img', {
      staticStyle: {
        "width": "22px",
        "height": "22px",
        "position": "absolute",
        "z-index": "100",
        "top": "initial",
        "left": "0"
      },
      attrs: {
        "src": require("../assets/img/is_owns.png"),
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "order-goods-name"
    }, [_vm._v(_vm._s(item.goodName))])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "order-default-font"
    }, [_vm._v(_vm._s(item.specName))]), _vm._v(" "), _c('div', {
      staticClass: "order-default-font"
    }, [_vm._v("SKU：" + _vm._s(item.productId))])]), _vm._v(" "), _c('td', {
      staticClass: "order-default-font"
    }, [_vm._v("¥" + _vm._s(item.cooperatePrice / 100))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.isContain))]), _vm._v(" "), _c('td', {
      staticClass: "order-default-font"
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), (_vm.orderDetailData.isBill == 1) ? _c('td', {
      staticClass: "order-default-font"
    }, [_vm._v("开发票")]) : _c('td', {
      staticClass: "order-default-font"
    }, [_vm._v("未开发票")]), _vm._v(" "), (index == 0) ? _c('td', {
      staticClass: "order-default-font",
      attrs: {
        "rowspan": _vm.goodsList.length
      }
    }, [_vm._v("¥" + _vm._s(_vm.orderDetailData.freight / 100))]) : _vm._e()])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v("包裹详情")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "300px"
    }
  }), _vm._v(" "), _c('th', [_vm._v("物流信息")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manage-config-info-title"
  }, [_c('span', {
    staticStyle: {
      "float": "left",
      "margin-left": "90px"
    }
  }, [_vm._v("包裹详情")]), _vm._v("\n        物流信息\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manage-config-info-title"
  }, [_c('div', {
    staticClass: "order-title-half"
  }, [_vm._v("收货人信息")]), _vm._v(" "), _c('div', {
    staticClass: "order-title-half"
  }, [_vm._v("订单信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("商品信息")]), _vm._v(" "), _c('th', [_vm._v("SKU")]), _vm._v(" "), _c('th', [_vm._v("最终结算价")]), _vm._v(" "), _c('th', [_vm._v("是否带票")]), _vm._v(" "), _c('th', [_vm._v("数量")]), _vm._v(" "), _c('th', [_vm._v("是否开票")]), _vm._v(" "), _c('th', [_vm._v("运费")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e50a5ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/OrderDetail.vue
// module id = 526
// module chunks = 1